import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { TimeBlock } from './get-time-blocks'

export const USE_GET_TIME_BLOCK_BY_ID_QUERY_KEY = 'useGetTimeBlockById'

export const getTimeBlockByIdQueryKey = (id: number) => [USE_GET_TIME_BLOCK_BY_ID_QUERY_KEY, id]

export const getTimeBlockById = async (id: number) => {
  const response = await authAPI.get<TimeBlock>(`/time-block/${id}`)
  return response.data
}

export const useGetTimeBlockById = (id?: number) =>
  useQuery({
    enabled: !!id,
    queryFn: () => getTimeBlockById(id!),
    queryKey: getTimeBlockByIdQueryKey(id!),
  })

export const useInvalidateTimeBlockById = () => {
  const queryClient = useQueryClient()
  return (id: number) => queryClient.invalidateQueries({ queryKey: getTimeBlockByIdQueryKey(id) })
}
